<template>
  <div>
    <h1>Task</h1>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
